import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import '../styles/FeatureStudio.css';

const FeatureStudio: React.FC = () => {
  useEffect(() => {
    document.title = 'Feature Studio | Personal Workspace';
  }, []);

  return (
    <Layout>
      <div className="feature-studio-container fade-in">
        <div className="feature-studio-header">
          <h1>Feature Studio</h1>
          <p>Design and manage product features</p>
        </div>
      </div>
    </Layout>
  );
};

export default FeatureStudio;
